
namespace GeniuzPOS.Inventory {
    import fld = IcStockTranRow.Fields
    @Serenity.Decorators.registerClass()
    export class IcStockTranGrid extends Serenity.EntityGrid<IcStockTranRow, any> {
        protected getColumnsKey() { return IcStockTranColumns.columnsKey; }
        protected getDialogType() { return IcStockTranDialog; }
        protected getIdProperty() { return IcStockTranRow.idProperty; }
        protected getInsertPermission() { return IcStockTranRow.insertPermission; }
        protected getLocalTextPrefix() { return IcStockTranRow.localTextPrefix; }
        protected getService() { return IcStockTranService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
			var button = super.getButtons();

            button.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: IcStockTranService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.DocDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(new Date().setDate(new Date().getDate()-13));

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

            return filters;
        }
    }
}